import React from "react";
import s from "./RadioButtonFilterGroup.module.scss";
import {useRadioButtonFilterGroupLogic} from "./RadioButtonFilterGroup.logic";

export interface IRadioButtonFilterGroupOptionItem <AvailableValues extends string = string> {
  label: string;
  value: AvailableValues;
}

export interface IRadioButtonFilterGroupProps <AvailableValues extends string = string> {
  value?: AvailableValues;
  options: IRadioButtonFilterGroupOptionItem<AvailableValues>[];
  onChange?: (newValue: AvailableValues) => void;
}

export const RadioButtonFilterGroup = <AvailableValues extends string = string>({value, onChange, options}: IRadioButtonFilterGroupProps<AvailableValues>) => {
  const {onChangeHandler, isOptionSelected} = useRadioButtonFilterGroupLogic<AvailableValues>({onChange, value});
  return <ol>
    {options.map((optionItem, index) => {
      // if current radio button is selected
      const {label, value: optionItemValue} = optionItem;
      const isSelected: boolean = isOptionSelected(optionItemValue);
      return (
        <li className={s.radioGroup} key={`radio-group-item-${index}-${optionItemValue}`}>
          <label>
            <input type={"radio"} value={optionItemValue} checked={isSelected} onChange={() => onChangeHandler(optionItemValue)} />
            <span className={s.radioLabel}>{label}</span>
          </label>
        </li>
      );
    })}
  </ol>;
}

